<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--welcomeback no_space']" id="open_box">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1> {{ getTranslations.home_modals_post_game_free_play_prize_yeah }}

          </h1>
          <h1> {{ getTranslations.home_modals_post_game_free_play_prize_won }} [{{ freePlayPrize.name }}]</h1>
        </div>


        <div class="modal__body achievement">

          <div class="open_box prize">


            <div class="open_box_container">
              <img id="pic-click" src="/static/images/free_game_assets/chest_static.jpg" />
              <img id="gif-click" src="/static/images/free_game_assets/chest_anim.gif" />

            </div>
            <a @click.prevent="savePoints()" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.home_modals_post_game_free_play_prize_claim }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'postGameFreePlayTreasureBox',
  data() {
    return {
      correctAnswersPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      homeScore: 0,
      awayScore: 0,
    };
  },
  created() {
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.homePlayerRoundScore * 100;
    if (this.gameWinnerMSISDN === 'trial user') {
      this.homeScore = 1;
      this.gameVictoryPoints = 200;
    } else {
      this.awayScore = 1;
    }
    this.totalEarnedPoints = this.correctAnswersPoints + this.gameVictoryPoints;
  },
  mounted() {
    console.log('in RoundEnded free play mounted hook:');
    this.$nextTick(() => {
      /* eslint-disable */
      const vm = this;
        $(function() {
      $('#gif-click').hide();
      $('#click').click(function() {
        $('#click').hide();
        $('#gif-click').show();
        $('#pic-click').hide();
      });

      if ($('#click').data("clicked", true)) {
        $('#gif-click').click(function() {
          $('#click').show();
          $('#gif-click').hide();
          $('#pic-click').show();
        });
      }

    });
    });
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    goToRegistration() {
      if (this.freeTrialRedirectionUrl) { // if property "free.trial.redirection.url" exists redirect to it otherwise to register1
        window.location.href = `${this.freeTrialRedirectionUrl}?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=trial&freeGamePrize=1`;
      } else {
        this.$router.push('/');
      }
    },
    savePoints() {
      this.$nextTick(() => {
      $('#click').hide();
      $('#gif-click').show();
      $('#pic-click').hide();
      });

      this.storeRegistrationPoints({
        freeGamePrize: 1000,
      });
      setTimeout(() => {
        this.goToRegistration();
      }, 3000);
    },
  },
  computed: {
    ...mapState('common', [
      'freeTrialRedirectionUrl',
    ]),
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameWinnerMSISDN',
    ]),
    ...mapState('profile', [
     'freePlayPrize',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'isEqualAmountOfCorrectAnswers',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
    determineWinnerCSSClass() {
      return (this.gameWinnerMSISDN === 'trial user') ? 'player1' : 'player2';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/PostGameFreePlayTreasureBox.vue